import * as Sentry from '@sentry/react';

export const defaultErrorHandler = errorBoundaryName => err => {
  Sentry.withScope(scope => {
    scope.setTag('error_boundary', errorBoundaryName);
    Sentry.captureException(err);
  });
};
